import { createAction } from '@reduxjs/toolkit';
import { StoreErrorPayload } from 'types/StoreErrorPayload';
import {
  AuthenticationResult,
  KontentProjectOverviewDTO,
  ResetPasswordDTO,
  UserDueDateChangeDTO,
  UserProjectPrefixDTO,
  VerifyTokenDTO,
} from 'utils/restApplicationClient';
import { AuthenticationRequest, ChangePasswordDTO } from 'utils/restApplicationClientTypeOverrides';
import { AuthActionTypes } from './auth.actions.types';

export const login = createAction<AuthenticationRequest>(AuthActionTypes.Login);

export const loginError = createAction<StoreErrorPayload>(AuthActionTypes.LoginError);

export const loginSuccess = createAction<AuthenticationResult>(AuthActionTypes.LoginSuccess);

export const refreshToken = createAction(AuthActionTypes.RefreshToken);

export const refreshTokenSuccess = createAction<AuthenticationResult>(AuthActionTypes.RefreshTokenSuccess);

export const verifyTokenSuccess = createAction<AuthenticationResult>(AuthActionTypes.VerifyTokenSuccess);

export const logoutUser = createAction(AuthActionTypes.LogoutUser);

export const logoutUserSuccess = createAction(AuthActionTypes.LogoutUserSuccess);

export const resetPassword = createAction<ChangePasswordDTO>(AuthActionTypes.ResetPassword);

export const resetPasswordSuccess = createAction(AuthActionTypes.ResetPasswordSuccess);

export const resetPasswordError = createAction(AuthActionTypes.ResetPasswordError);

export const forgotPassword = createAction<ResetPasswordDTO>(AuthActionTypes.ForgotPassword);

export const forgotPasswordSuccess = createAction(AuthActionTypes.ForgotPasswordSuccess);

export const forgotPasswordError = createAction(AuthActionTypes.ForgotPasswordError);

export const verifyResetPasswordToken = createAction<VerifyTokenDTO>(AuthActionTypes.VerifyResetPasswordToken);

export const verifyResetPasswordTokenSuccess = createAction(AuthActionTypes.VerifyResetPasswordTokenSuccess);

export const verifyResetPasswordTokenError = createAction(AuthActionTypes.VerifyResetPasswordTokenError);

export const getKenticoProject = createAction<AuthenticationResult>(AuthActionTypes.GetKenticoProject);

export const getKenticoProjectError = createAction(AuthActionTypes.GetKenticoProjectError);

export const chooseKenticoProject = createAction<KontentProjectOverviewDTO>(AuthActionTypes.ChooseKenticoProject);

export const getProjectPrefix = createAction(AuthActionTypes.GetProjectPrefix);

export const getProjectPrefixSuccess = createAction<UserProjectPrefixDTO>(AuthActionTypes.GetProjectPrefixSuccess);

export const getProjectPrefixError = createAction(AuthActionTypes.GetProjectPrefixError);

export const getUserConfig = createAction(AuthActionTypes.GetUserConfig);

export const getUserConfigError = createAction(AuthActionTypes.GetUserConfigError);

export const getUserConfigSuccess = createAction<UserDueDateChangeDTO>(AuthActionTypes.GetUserConfigSuccess);
